import { AgreementI } from "../interfaces/agreements.interface";

export const state: AgreementI = {
  agreements: [],
}
